export const AudienceTypeValues = ['AC', 'CB', 'CC', 'CO', 'DC', 'TC', 'RC'] as const;
export const AnnouncementAudienceTypeValues = [
  ...AudienceTypeValues,
  'CBB',
  'RG',
  'RCO',
  'RCB',
] as const;

export type AudienceTypes = (typeof AudienceTypeValues)[number];
export type AnnouncementAudienceType = (typeof AnnouncementAudienceTypeValues)[number];

export const Audiences = new Map<AudienceTypes, string>([
  ['AC', 'Apheresis Centers'],
  ['CB', 'Cord Blood Banks'],
  ['CC', 'Collection Centers'],
  ['CO', 'Cooperative Registry'],
  ['DC', 'Donor Centers'],
  ['TC', 'Transplant Centers'],
  ['RC', 'Research Centers'],
]);

const researchCenter = `Research Center`;

export const AnnouncementAudiences = new Map<AnnouncementAudienceType, string>([
  ['AC', 'Apheresis Center'],
  ['CB', 'Cord Blood Bank'],
  ['CBB', 'Cord Blood Bank'],
  ['CC', 'Collection Center'],
  ['CO', 'Cooperative Registry'],
  ['DC', 'Donor Center'],
  ['TC', 'Transplant Center'],
  ['RG', 'Recruitment Group'],
  ['RC', researchCenter],
  ['RCO', researchCenter],
  ['RCB', researchCenter],
]);

export const publicCenterIds = [
  'AC_Extras',
  'CB_Extras',
  'CC_Extras',
  'CO_Extras',
  'DC_Extras',
  'TC_Extras',
];

export const accessCentersMexico = ['ACMEX', 'CBMEX', 'CCMEX', 'COMEX', 'DCMEX', 'TCMEX'];

export const accessCentersIntl = ['ACINTL', 'CBINTL', 'CCINTL', 'COINTL', 'DCINTL', 'TCINTL'];

export const accessCentersUsa = ['ACUSA', 'CBUSA', 'CCUSA', 'COUSA', 'DCUSA', 'TCUSA'];

export const distinctAudiencesFromMap = (
  map: Map<string, string>,
  centerTypes: string[]
): string[] => {
  const retMap = new Map<string, boolean>();
  centerTypes.forEach((centerType: string) => {
    const typeValue = map.get(centerType);
    if (typeValue) {
      retMap.set(typeValue, true);
    }
  });
  return Array.from(retMap.keys());
};
export const distinctAnnouncementAudiencesForCenterTypes = (centerTypes: string[]): string[] => {
  return distinctAudiencesFromMap(AnnouncementAudiences, centerTypes);
};
/**
 * Parsed region access bits
 */
export type ParsedRegionClaim = {
  isUs: boolean;
  isIntl: boolean;
  isMexico: boolean;
  equals(region: ParsedRegionClaim): boolean;
};

/**
 * Parses region claims into US vs Intl bits.
 * @param parsedRegions Parsed region access.
 * @returns Parsed region access bits.
 */
export const parseRegionClaim = (regionsClaim: string[] | undefined | null): ParsedRegionClaim => {
  const isUs = (regionsClaim ?? []).includes('United States');
  const isIntl = (regionsClaim ?? []).includes('Non United States');
  const isMexico = (regionsClaim ?? []).findIndex((x) => /[lp]1_nrc_region_mexico/i.test(x)) !== -1;
  const regionClaimEquals = (region: ParsedRegionClaim): boolean =>
    isUs === region.isUs && isIntl === region.isIntl && isMexico === region.isMexico;
  return {
    isUs,
    isIntl,
    isMexico,
    equals: regionClaimEquals,
  };
};
